import React from 'react';

import { isDefined } from '@nfctron/nexus-core';
import { cn } from '@nfctron/nexus-react';

import { Checkbox as MantineCheckbox } from '@mantine/core';

import { type Component, type ComponentDisplayName } from '@root/lib/types/components';

import { type CheckboxProps } from './Checkbox.types';

/**
 * Checkbox component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const Checkbox: Component<CheckboxProps> = ({ error, ...rest }) => {
	return (
		<MantineCheckbox
			{...rest}
			classNames={{
				label: cn([isDefined(error) && 'text-red-500!']),
				input: cn([isDefined(error) && 'border-red-500!']),
			}}
		/>
	);
};

/**
 * Checkbox component display name
 * @type {ComponentDisplayName}
 */
Checkbox.displayName = 'component/Checkbox';
